import { Component, OnInit } from '@angular/core';
import { BillingControlService } from '../service/billing-control.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { BcClientListComponent } from '../../bc-client-list/bc-client-list.component';

@Component({
  selector: 'app-bc-sent-to-juridical',
  templateUrl: './bc-sent-to-juridical.component.html',
  styleUrls: ['./bc-sent-to-juridical.component.scss']
})
export class BcSentToJuridicalComponent implements OnInit {

  private isLoaded = false;
  private BCJudicialData = [];
  private BCSentToJudicialDataByMonth = [];
  private BCSentToJudicialDataByYear = [];

  constructor(private billingControlService: BillingControlService, private dialogService: DialogService) {
  }

  ngOnInit() {
  }

  onOpenAccordion() {
    if (this.isLoaded == false) {
      this.getBCSentToJudicial();
    }
  }

  getBCSentToJudicial() {
    this.billingControlService.getBCSentToJudicial().subscribe(result => {
      if (result.Success) {
        this.BCJudicialData = result.Result || [];

        this.BCJudicialData.forEach(item => {
          if (item.Mes != "")
            this.BCSentToJudicialDataByMonth.push(item);
          else if (item.Year != "")
            this.BCSentToJudicialDataByYear.push(item);
        });

        this.isLoaded = true;
      } else {
        console.log("Erro ao carregar dados de Enviados ao Jurídico");
      }
    }, error => {
      console.log(error);
    });
  }

  openModal(tipo, chave, dias) {
    const objToList = {
      Tipo: tipo,
      Chave: chave == '' ? undefined : chave,
      Dias: dias,
      Diretoria: this.billingControlService.selectedDirectorship
    };
    this.dialogService.addDialog(BcClientListComponent, { obj: objToList }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
  }

  getMonthDesc(month) {
    switch (month) {
      case "1": return "Janeiro";
      case "2": return "Fevereiro";
      case "3": return "Março";
      case "4": return "Abril";
      case "5": return "Maio";
      case "6": return "Junho";
      case "7": return "Julho";
      case "8": return "Agosto";
      case "9": return "Setembro";
      case "10": return "Outubro";
      case "11": return "Novembro";
      case "12": return "Dezembro";
      default: "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/bc-sent-to-juridical/bc-sent-to-juridical.component.ts